import SectionHead from '@/components/general/SectionHead';
import React from 'react';
import styles from '../styles.module.css';
import { Car, Plate } from '@/commonTypes';
import PlateBadge from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import { useLayoutContext } from '@/context/LayoutContext';

export default function SideBarGarage({
  badge = 'گاراژ فعال',
  title1 = 'چه کسی پشت',
  title2 = 'فرمان است؟',
  text = 'خودروی موردنظر را انتخاب کنید یا کاربر زیرمجموعهٔ جدیدی به گاراژ بیفزایید.',
}) {
  const { activeCar } = useLayoutContext();
  let sample = {
    plate: TransformPlateNumber('ایران ۸۸ - ۴۱۴ ج ۸۷'),
    name: 'پریا رحیمی',
    id: 1,
  };
  return (
    <div className={`${styles.garagHead}`}>
      <SectionHead
        badge={badge}
        title={
          <>
            {title1} <span className={'titleGrad'}>{title2}</span>
          </>
        }
        text={text}
        titleClass={`${styles.titleClass}`}
        textTitle={`${styles.textClass}`}
        type="otherPages"
      />

      <PlateBadge
        car={activeCar ? activeCar : sample}
        type="large"
        size="xl"
        showAnimation={true}
        className={`${styles.garageHeadPlate}`}
        classA={styles.a}
        classB={styles.b}
        classC={styles.c}
      />
    </div>
  );
}
